import type { BatMetadataConfigEntry } from './common/types';
import { coreFields } from './common/coreFields';
import { productFields, productField } from './common/productFields';
import { msg } from '@lingui/core/macro';

export const soldProductCircularityMetadata = {
  displayName: msg({
    message: 'Sold products: Durability',
    context: 'Activity data schema name for sold product circularity',
  }),
  fields: {
    ...coreFields,
    ...productFields,
    durability: {
      displayName: msg({
        message: 'Product durability',
        context: 'The display name for a dimension',
      }),
      externalDescription: msg({
        message:
          'The expected lifespan or durability classification of the sold product.',
      }),
    },
    industry_average_durability: {
      displayName: msg({
        message: 'Product durability industry average',
        context: 'The display name for a dimension',
      }),
      externalDescription: msg({
        message:
          'The industry-standard product lifespan used for circularity benchmarking.',
      }),
    },
    product_name: productField,
    repairability: {
      displayName: msg({
        message: 'Product repairability',
        context: 'The display name for a dimension',
      }),
      externalDescription: msg({
        message:
          'The repairability score or rating assigned to the sold product.',
      }),
    },
    repairability_rating_system: {
      displayName: msg({
        message: 'Product repairability rating system',
        context: 'The display name for a dimension',
      }),
      externalDescription: msg({
        message:
          'The rating system or standard used to assess product repairability.',
      }),
    },
  },
} as const satisfies BatMetadataConfigEntry;
